import BaseApi from './base.api'

export default {
    ...BaseApi,
    ...{
        resource: 'invoice-categories'
    }
}
